import { useMemo, useRef } from "react";

import type { MutableRefObject } from "react";

/**
 * Like `useRef` but with get and set handlers.
 */
export function useHookableRef<T>(
  initialValue: T | null = null,
  onSet?: (v: T) => T,
  onGet?: (v: T) => T,
): MutableRefObject<T | null> {
  const onSetRef = useRef(onSet);
  const onGetRef = useRef(onGet);

  return useMemo(() => {
    let v = initialValue;

    return {
      get current() {
        return onGetRef.current === undefined ? v : onGetRef.current(v as T);
      },

      set current(_v) {
        v = onSetRef.current === undefined ? _v : onSetRef.current(_v as T);
      },
    };
  }, [initialValue]);
}
